<template>
  <span>
    <div v-if="hastoRefresh" class="haveToRefreshApp">
      <div class="animated fadeIn">
            <div class="card  mb-0">

              <!--<div><span v-on:click="reloadpage" class="btn btn-secondary">{{$t('global.reloadpage')}}</span></div>-->
              <div class="card-footer">
                {{$t('global.reloadpageText')}}
                <span v-on:click="reloadpage" class="btn btn-secondary float-right">{{$t('global.reloadpage')}}</span>
                <!--<button type="submit" class="btn btn-primary btn-sm" v-on:click="langsave()">-->
                <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.submit')}}-->
                <!--</button>-->
              </div>


            </div>
          </div>
    </div>
    <span v-if="!hastoRefresh"></span>

</span>
</template>

<script>
  import Api from '@/api/Api';
  import HelperRole from "@/helper/HelperRole";
  import Helper from "@/helper/Helper";

  export default {
    name: 'HealthChecker',
    mounted() {
      const modul = this;
      if (localStorage.getItem("accesstoken")) {
        modul.accesstoken = localStorage.getItem("accesstoken");
      }
      if (modul.delay > 0) {
        modul.cdelay = this.delay
      }
      modul.healthCheck();
      modul.timer = setInterval(modul.healthCheck, modul.cdelay)
      modul.$eventBus.$on('HealthChecker', this.HealthCheckerEventHandler);
    },
    beforeDestroy() {
      const modul = this;
      modul.$eventBus.$off('HealthChecker');
      clearInterval(this.timer);
    },
    data() {
      return {
        accesstoken: "",
        cdelay: 30000,
        remaintime: '',
        status: true
        , state: {}
        , stateHash: ""
        , hastoRefresh: false

      };
    },
    props: {
      delay: Number,
    },
    watch: {
      accesstoken: function (newLang, oldLang) {
      },
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;

        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          console.log("modul.state")
          console.log(modul.state)

//          if(modul.state.frontendVersion && modul.state.appVersion){
//            const frontendVersion = modul.state.frontendVersion.replace(/"/g, '').replace(/'/g, '');
//            const appVersion = modul.state.appVersion.replace(/"/g, '').replace(/'/g, '');
//            const hastoRefresh = Helper.checkAppVersion(frontendVersion, appVersion);
//            modul.hastoRefresh = hastoRefresh;
//          }
          if(modul.state.adminVersion && modul.state.appVersion){
            const adminVersion = modul.state.adminVersion.replace(/"/g, '').replace(/'/g, '');
            const appVersion = modul.state.appVersion.replace(/"/g, '').replace(/'/g, '');
            const hastoRefresh = Helper.checkAppVersion(adminVersion, appVersion);
            modul.hastoRefresh = hastoRefresh;
          }
        }
      },

    },
    methods: {
      reloadpage(){
        const modul = this;
        location.reload(true);
      },

      HealthCheckerEventHandler(o){
        const modul = this;
        if (o.command && o.command === "do") {
          modul.healthCheck();
        } else {
          modul.status = o.status;
        }
      },
      healthCheck(){
        const modul = this;
        if (modul.status) {
          if (modul.$router.currentRoute && modul.$router.currentRoute.name !== "login" && modul.$router.currentRoute.name !== "register" && modul.$router.currentRoute.name !== "remember" && modul.$router.currentRoute.name !== "pset") { // routename
            Api.healthCheck({}).then(function (res) {
                HelperRole.healthCheckHandler(modul, res);
              }, function (res) {
                HelperRole.healthCheckHandler(modul, res);
              }
            );
          }
        }
      },
    }
  };
</script>

<style>
  .cursor {
    cursor: pointer;
  }
  .haveToRefreshApp{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 50px;
  }
</style>
